var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "margin-top" },
        [
          _c(
            "el-col",
            [
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Nome:",
                  content: _vm.cadastroGleba.nomeCadastrante || "-"
                }
              }),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "CPF:",
                  content: _vm.cadastroGleba.cpfCadastrante || "-"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6423d86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6423d86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/bancoDados/components/InformacoesCadastrante.vue
// module id = null
// module chunks = 